/**
 * Created by abahlk on 23.06.2014.
 */

import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { InstanceErrorLOFactory } from "./InstanceErrorLOFactory";

export class InvalidCountryNetworkConfigurationLOFactory extends InstanceErrorLOFactory {
    private static PARAM_GGS_COUNTRY_CODE: string = "ggsCountryCode";

    private _ggsCountryCode: string;

    constructor(subErrorId: number, ggsCountryCode: string) {
        super(subErrorId);

        this._ggsCountryCode = ggsCountryCode;
    }

    public create(): AbstractLogObject {
        let lo: AbstractLogObject = super.create();

        lo.logData.set(InvalidCountryNetworkConfigurationLOFactory.PARAM_GGS_COUNTRY_CODE, this._ggsCountryCode);

        return lo;
    }
}
